// =============================================================================
// ! Open PDFs in new tab/window
// =============================================================================
jQuery(function($) {
	$('a[href$=".pdf"]').attr('target', '_blank');
});

// =============================================================================
// ! Open Ext links via new tab/window
// adapted from http://www.unseenrevolution.com/jquery-external-links-new-window/
// =============================================================================
jQuery(function($) {
	$("a[href*='http://']:not([href*='"+location.hostname.replace
		("www.","")+"'])").each(function() {
			$(this).click(function(event) {
				event.preventDefault();
				event.stopPropagation();
				window.open(this.href, '_blank');
			}).addClass('external-link');
		});
	});
jQuery(function($) {
	$("a[href*='https://']:not([href*='"+location.hostname.replace
		("www.","")+"'])").each(function() {
			$(this).click(function(event) {
				event.preventDefault();
				event.stopPropagation();
				window.open(this.href, '_blank');
			}).addClass('external-link');
		});
	});
